import React from "react";
import { Tooltip } from "@material-ui/core";
import DefaultButton from "components/items/default-button";
import { LinkIcon } from "helpers/icon-finder";

const ViewExternalLinkButton = ({
  externalLink,
}) => {
  const label = `${externalLink?.linkName ?? "External Link"}`;

  const handleClick = () => {
    if (externalLink?.linkUrl) {
      window.open(externalLink.linkUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Tooltip title={`Go to ${label}`}>
      <div className="flex">
        <DefaultButton
          variant="outlined"
          label={(
            <span className="flex items-center">
              {label}
              <LinkIcon style={{ marginLeft: "5px" }} size={16} />
            </span>
          )}
          onClick={handleClick}
        />
      </div>
    </Tooltip>
  );
};

export default ViewExternalLinkButton;
